import { render, staticRenderFns } from "./DesignComponentsControl.vue?vue&type=template&id=54fbacff&scoped=true"
import script from "./DesignComponentsControl.vue?vue&type=script&lang=js"
export * from "./DesignComponentsControl.vue?vue&type=script&lang=js"
import style0 from "./DesignComponentsControl.vue?vue&type=style&index=0&id=54fbacff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fbacff",
  null
  
)

/* custom blocks */
import block0 from "./DesignComponentsControl.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports